import {
  buildSubscriptionStatusSnapshot,
  type SubscriptionRecord,
} from "@/utils/subscriptionPlanState";

/**
 * Fetch Subscription Status Snapshot.
 */
export async function fetchSubscriptionStatusSnapshot(userId: string) {
  const { getCurrentSubscription } = await import("@/services/subscriptionService");
  const subscription = (await getCurrentSubscription(userId)) as SubscriptionRecord | null;

  if (import.meta.env.DEV && subscription) {
    console.warn("Subscription data:", subscription);
  }

  const snapshot = buildSubscriptionStatusSnapshot(subscription);

  if (import.meta.env.DEV) {
    console.warn("Calculated subscription status:", snapshot);
  }

  return snapshot;
}

export function resolveSubscriptionDisplayName(planDisplayName?: string): string {
  return planDisplayName || "Free";
}
